import { BatchVideoRequest, EventAttachmentType } from 'api/Assessor/video';
import { AxiosError } from 'axios';
import LayoutContext from 'components/Layout/LayoutContext';
import AddAttachment from 'components/Modal/AddAttachment';
import VideoAssembly from 'components/Modal/VideoAssembly';
import { AuthContext } from 'context/authContext/AuthContext';
import { RegisterContextActions } from 'context/registerContext/RegisterContextActions';
import {
  AssemblyModalities,
  AssemblyType,
  SituationValues,
  StepIds,
  StepStatus,
} from 'helpers/enums/Assembleia';
import { getProfileByJWTRoles } from 'helpers/utils/AuthUtils';
import { clsx, isNullOrUndefined } from 'helpers/utils/HTMLUtils';
import {
  getParsedJWTAssessorAccessToken,
  JWTAssessorJson,
} from 'helpers/utils/JWTUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import { useRegisterContext } from 'hooks/useRegisterContext';
import {
  AssessorCadastroEventoRoutePath,
  AssessorCadastroReuniaoRoutePath,
  AssessorRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import moment from 'moment';
import {
  AddCircleIcon,
  ArrowLeftIcon,
  Button,
  ButtonThemes,
  CheckCircleIcon,
  ChevronArrowDownIcon,
  Col,
  Collapse,
  DestructiveModal,
  DropdownItem,
  DropdownMenu,
  EditIcon,
  IconButton,
  LeftCheckboxWithLabel,
  ModalSizes,
  OptionsIcon,
  Pagination,
  Row,
  ScreenSize,
  TableWithOverflow,
  Title,
  ToastTypes,
  TrashIcon,
  useDropOpened,
} from 'plataforma-fundacao-componentes';
import {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
  assembleiaAssessorActionsDeleteVideo,
  assembleiaAssessorActionsDeleteVideoBatch,
  assembleiaAssessorActionsRemoveDocument,
  assembleiasAssessorLoadEventAttachment,
  assembleiasAssessorMakeAvailableEvent,
} from 'store/modules/AssembleiasAssessorActions';
import {
  AuthUserPerfilId,
  IAuthUserPerfil,
} from 'store/modules/auth/IAuthUserPerfil';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { makeEditable, previousStepIsCompleted } from '../../Cadastro';
import styles from './styles.module.scss';

const attachmentPrefix = translation.Assessor.Evento.Cadastro.Etapas.Anexo;

export default function Attachment(props: { reu?: boolean }) {
  const [selected, setSelected] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [opened, setOpened] = useState<number[]>([]);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [editButtonLoader, setEditButtonLoader] = useState<boolean>(false);
  const [pageSize] = useState<number>(10);

  const history = useHistory();
  const dispatchAction = useDispatch();
  const { state, changeState } = useRegisterContext();
  const { showToast } = useContext(LayoutContext);
  const { user } = useContext(AuthContext);
  const match = useRouteMatch<{ id?: string; etapa?: string }>();
  const { setStepId, setStepStatus } = useRegisterContext();
  const [dropOpened, toggleDropOpened] = useDropOpened<number | undefined>(
    undefined
  );

  const parsedToken: JWTAssessorJson | null = getParsedJWTAssessorAccessToken(
    user!.access_token
  );
  const perfil: IAuthUserPerfil | null = parsedToken
    ? getProfileByJWTRoles(parsedToken.roles)
    : null;

  const indexOfLastData = currentPage * pageSize;
  const indexOfFirstData = indexOfLastData - pageSize;
  const currentDataTable =
    state.attachments.files && state.attachments.files.length > pageSize
      ? state.attachments.files.slice(indexOfFirstData, indexOfLastData)
      : state.attachments.files;

  const completedStep =
    state.data.campos.modality === AssemblyModalities.OFFLINE &&
    state.eventStatus === SituationValues.BLOCKED
      ? false
      : state.completed.find(
          (item: { step: StepIds }) => item.step === StepIds.attachment
        )?.completed && state.status !== StepStatus.EM_EDICAO;

  const isAgn = useMemo(() => {
    return state.data.campos.type! === AssemblyType.AGN;
  }, [state.data.campos.type]);

  const openAddAttachmentModal = useCallback(
    (idAttachment?: string | string[]) => {
      const id = getUniqueKey();

      let item = undefined;
      if (idAttachment && idAttachment.length) {
        item = state.attachments.files.filter((e: { oidDocumento: string }) =>
          idAttachment[0]!?.includes(e.oidDocumento)
        );
      }

      dispatchAction(
        openModal(AddAttachment, {
          eventId: Number(match.params.id!),
          registeting: true,
          modalKey: id,
          preventEscExit: true,
          preventMaskExit: true,
          mobileOn: ScreenSize.xs,
          edit: item && {
            file: item[0],
          },
          shouldUseBff: true,
          onClose: () => {
            closeModal(id);
          },
          onConfirm: () =>
            new Promise<void>((resolve, reject) => {
              closeModal(id);
              setSelected([]);

              dispatchAction(
                assembleiasAssessorLoadEventAttachment(
                  Number(match.params.id!),
                  (e: any) => {
                    changeState(
                      RegisterContextActions.ATTACHMENT_TABLE_DATA,
                      e.documents.concat(e.videos)
                    );
                    resolve();
                  },
                  reject
                )
              );
            }),
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [match.params.id, state.attachments.files, dispatchAction]
  );

  const openAddVideoModal = useCallback(
    (idAttachment?: string | string[]) => {
      const id = getUniqueKey();

      let item = undefined;
      if (idAttachment && idAttachment.length) {
        item = state.attachments.files.filter((e: { idVideo: string }) =>
          idAttachment[0]!?.includes(e.idVideo)
        );
      }

      dispatchAction(
        openModal(VideoAssembly, {
          eventId: Number(match.params.id),
          registering: true,
          modalKey: id,
          preventEscExit: true,
          preventMaskExit: true,
          mobileOn: ScreenSize.xs,
          item: item ? item[0] : undefined,
          shouldUseBff: true,
          onClose: () => {
            closeModal(id);
          },
          onConfirm: () =>
            new Promise<void>((resolve, reject) => {
              closeModal(id);
              setSelected([]);

              dispatchAction(
                assembleiasAssessorLoadEventAttachment(
                  Number(match.params.id!),
                  (e: any) => {
                    changeState(
                      RegisterContextActions.ATTACHMENT_TABLE_DATA,
                      e.documents.concat(e.videos)
                    );
                    resolve();
                  },
                  reject
                )
              );
            }),
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [match.params.id, state.attachments.files, dispatchAction]
  );

  const deleteModal = useCallback(
    (id: string, isVideoAttachment: boolean) => {
      const mk = getUniqueKey();

      dispatchAction(
        openModal(DestructiveModal, {
          modalKey: mk,
          title: 'Deletar',
          size: ModalSizes.Large,
          mobileOn: ScreenSize.xs,
          children:
            'O anexo selecionado será removido da lista. Confirma exclusão?',
          onClose: () => {
            dispatchAction(closeModal(mk));
          },
          onCancel: () => {
            dispatchAction(closeModal(mk));
          },
          onConfirm: () => {
            return new Promise<void>((resolve, reject) => {
              const action = isVideoAttachment
                ? assembleiaAssessorActionsDeleteVideo
                : assembleiaAssessorActionsRemoveDocument;
              dispatchAction(
                action(
                  String(match.params.id!),
                  Number(id!),
                  true,
                  () => {
                    setSelected([]);
                    dispatchAction(
                      assembleiasAssessorLoadEventAttachment(
                        Number(match.params.id!),
                        (e: any) => {
                          changeState(
                            RegisterContextActions.ATTACHMENT_TABLE_DATA,
                            e.documents.concat(e.videos)
                          );
                          dispatchAction(closeModal(mk));
                          if (selected.length === currentDataTable.length) {
                            setCurrentPage(1);
                          }
                          resolve();
                        }
                      )
                    );
                  },
                  (error) => {
                    showToast({
                      pauseOnFocusLoss: true,
                      theme: ToastTypes.Error,
                      showStatusBar: true,
                      timeout: 4000,
                      label: languageValues.toasts.error.keyErrors(
                        error.message
                      ),
                    });
                    reject();
                  }
                )
              );
            });
          },
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]
  );

  const deleteBatchModal = useCallback(
    (data: BatchVideoRequest) => {
      const mk = getUniqueKey();

      dispatchAction(
        openModal(DestructiveModal, {
          modalKey: mk,
          title: 'Deletar',
          size: ModalSizes.Large,
          mobileOn: ScreenSize.xs,
          children:
            'O(s) anexos(s) selecionado(s) serão removido(s) da lista. Confirma exclusão?',
          onClose: () => {
            dispatchAction(closeModal(mk));
          },
          onCancel: () => {
            dispatchAction(closeModal(mk));
          },
          onConfirm: () => {
            return new Promise<void>((resolve, reject) => {
              dispatchAction(
                assembleiaAssessorActionsDeleteVideoBatch(
                  Number(match.params.id),
                  data,
                  () => {
                    setSelected([]);
                    dispatchAction(
                      assembleiasAssessorLoadEventAttachment(
                        Number(match.params.id!),
                        (e: any) => {
                          changeState(
                            RegisterContextActions.ATTACHMENT_TABLE_DATA,
                            e.documents.concat(e.videos)
                          );
                          dispatchAction(closeModal(mk));
                          if (selected.length === currentDataTable.length) {
                            setCurrentPage(1);
                          }
                          resolve();
                        }
                      )
                    );
                  },
                  (error) => {
                    showToast({
                      pauseOnFocusLoss: true,
                      theme: ToastTypes.Error,
                      showStatusBar: true,
                      timeout: 4000,
                      label: languageValues.toasts.error.keyErrors(
                        error.message
                      ),
                    });
                    reject();
                  }
                )
              );
            });
          },
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]
  );

  const handleSubmit = useCallback(
    async () => {
      setLoadingButton(true);

      dispatchAction(
        assembleiasAssessorMakeAvailableEvent(
          Number(match.params.id!),
          () => {
            setLoadingButton(false);
            history.push(AssessorRoutePath);
          },
          (error) => {
            showToast({
              pauseOnFocusLoss: true,
              theme: ToastTypes.Error,
              showStatusBar: true,
              timeout: 4000,
              label:
                translation.Toasts.Errors.Keys[
                  `${
                    error.response?.data.message ||
                    error.response?.data ||
                    error.message
                  }` as keyof typeof translation.Toasts.Errors.Keys
                ] ?? translation.Toasts.Errors.defaultAlternative,
            });
            setLoadingButton(false);
          }
        )
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatchAction]
  );

  const showDeleteUpperHeaderButton = useCallback(
    (data: any) => {
      return {
        type: 'Button' as const,
        leftIcon: <TrashIcon />,
        label: attachmentPrefix.Table.UpperHeader.Deletar,
        disabled: !data || !data.length,
        onClick: () => {
          const teste = data.map(
            (e: { id: string; type: EventAttachmentType }) => {
              return {
                attachmentId: e.id,
                attachmentType: e.type,
              };
            }
          );
          deleteBatchModal({
            attachments: teste,
          });
        },
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]
  );

  function getFileExtension(fileName: string): string {
    const parts = fileName.split('.');
    return parts[parts.length - 1];
  }

  useEffect(() => {
    setStepId(StepIds.attachment);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!previousStepIsCompleted(state.completed, StepIds.attachment)) {
      if (isAgn) {
        if (isAgn) {
          history.push(
            `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pesquisa`
          );
        } else {
          if (props.reu) {
            history.push(
              `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/pauta`
            );
          } else {
            history.push(
              `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pauta`
            );
          }
        }
      }
    }
  }, [history, isAgn, match.params.id, props.reu, state.completed]);

  return (
    <Row className={styles.root}>
      <Row className={styles.title_content}>
        <Col cols={[12, 12, 6, 6, 6]}>
          <Row>
            <Title>{attachmentPrefix.Titulo}</Title>
            {state.data.campos.flgEventTest ? (
              <span
                style={{
                  color: '#e60000',
                  fontSize: '12px',
                  marginTop: '12px',
                }}
              >
                {props.reu
                  ? translation.Assessor.Evento.Cadastro.Etapas.Dados
                      .EventoTesteREU
                  : translation.Assessor.Evento.Cadastro.Etapas.Dados
                      .EventoTeste}
              </span>
            ) : (
              <Fragment />
            )}
          </Row>
        </Col>

        {[SituationValues.AVAILABLE, SituationValues.IN_PREPARATION].includes(
          state.eventStatus!
        ) &&
        ((state.status !== StepStatus.EM_EDICAO &&
          [AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!) &&
          props.reu) ||
          ![AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!)) ? (
          <Col cols={[12, 12, 6, 6, 6]} end buttonActionsCol>
            <Button
              theme={ButtonThemes.Primary}
              leftIcon={<EditIcon />}
              onClick={() => {
                setEditButtonLoader(true);
                makeEditable(
                  String(match.params.id),
                  () => {
                    setEditButtonLoader(false);
                    setStepStatus(StepStatus.EM_EDICAO);
                    changeState(
                      RegisterContextActions.SET_EVENT_STATUS,
                      SituationValues.EDITABLE
                    );
                  },
                  (error) => {
                    setEditButtonLoader(false);
                    showToast({
                      pauseOnFocusLoss: true,
                      theme: ToastTypes.Error,
                      showStatusBar: true,
                      timeout: 4000,
                      label:
                        translation.Toasts.Errors.Keys[
                          `${
                            (error as AxiosError<Error>).response?.data
                              .message ||
                            (error as AxiosError<Error>).response?.data ||
                            (error as AxiosError<Error>).message
                          }` as keyof typeof translation.Toasts.Errors.Keys
                        ] ?? translation.Toasts.Errors.defaultAlternative,
                    });
                  }
                );
              }}
              disabled={editButtonLoader}
              loading={editButtonLoader}
            >
              {attachmentPrefix.Buttons.Editar}
            </Button>
          </Col>
        ) : undefined}
        <Col>{attachmentPrefix.Subtitulo()}</Col>
      </Row>

      <Row>
        <Col gap={16} noPaddingTop>
          <Button
            theme={ButtonThemes.Primary}
            leftIcon={<AddCircleIcon />}
            onClick={() => openAddAttachmentModal()}
            disabled={completedStep}
          >
            {attachmentPrefix.Buttons.AdicionarPDF}
          </Button>
          <Button
            theme={ButtonThemes.Primary}
            leftIcon={<AddCircleIcon />}
            onClick={() => openAddVideoModal()}
            disabled={completedStep}
          >
            {attachmentPrefix.Buttons.AdicionarVideo}
          </Button>
        </Col>
      </Row>

      <Collapse
        opened={Boolean(
          state.attachments.files && state.attachments.files.length
        )}
        animateOpacity
      >
        <Row style={{ margin: '20px 0px 0px 0px' }}>
          <Col className={styles.table}>
            <TableWithOverflow
              showTopNavigator={false}
              noResultMessage={'Este evento não tem anexos'}
              columns={[
                {
                  key: 'checkbox',
                  props: {
                    align: 'left',
                    style: { width: '80px' },
                  },
                  value: (
                    <LeftCheckboxWithLabel
                      anchorLabelToCheckbox={
                        state.status !== StepStatus.VISUALIZACAO ||
                        !completedStep
                      }
                      label={attachmentPrefix.Table.Head.Tipo}
                      value={
                        Boolean(selected!?.length) &&
                        selected!?.length === currentDataTable!?.length
                      }
                      onChange={(val) => {
                        if (val) {
                          setSelected(
                            currentDataTable!?.map(
                              (a: {
                                oidDocumento?: string;
                                idVideo?: string;
                              }) => {
                                return {
                                  id: String(
                                    a.oidDocumento ? a.oidDocumento : a.idVideo
                                  ),
                                  type: a.oidDocumento
                                    ? EventAttachmentType.ATTACHMENT
                                    : EventAttachmentType.VIDEO,
                                };
                              }
                            )
                          );
                        } else {
                          setSelected([]);
                        }
                      }}
                      disabled={
                        state.status === StepStatus.VISUALIZACAO &&
                        state.eventStatus === SituationValues.BLOCKED
                          ? false
                          : state.status === StepStatus.VISUALIZACAO ||
                            completedStep
                      }
                    />
                  ),
                },
                {
                  key: 'title',
                  props: {
                    align: 'left',
                    style: {
                      maxWidth: '300px',
                      overflow: 'hidden',
                    },
                  },
                  value: attachmentPrefix.Table.Head.Titulo,
                },
                {
                  key: 'description',
                  props: {
                    align: 'left',
                    style: {
                      maxWidth: '300px',
                    },
                  },
                  value: attachmentPrefix.Table.Head.Descricao,
                },
                {
                  key: 'date',
                  props: {
                    align: 'left',
                    style: {
                      maxWidth: '150px',
                    },
                  },
                  value: attachmentPrefix.Table.Head.Date,
                },
                {
                  key: 'visibility',
                  props: {
                    align: 'left',
                    style: {
                      maxWidth: '100px',
                    },
                  },
                  value: attachmentPrefix.Table.Head.Visibilidade,
                },

                {
                  key: 'actions',
                  value: '',
                  props: { style: { width: '160px' } },
                },
              ]}
              lines={currentDataTable!?.map((row: any, index: number) => {
                return {
                  key: index,
                  checkbox: (
                    <LeftCheckboxWithLabel
                      label={
                        row.oidDocumento
                          ? getFileExtension(row.nomDocumento)
                          : 'Vídeo'
                      }
                      value={
                        selected
                          .map((e) => e.id)
                          .indexOf(
                            String(
                              row.oidDocumento ? row.oidDocumento : row.idVideo
                            )
                          )! > -1
                      }
                      onChange={(v) => {
                        let sel = [...selected!];
                        if (v) {
                          sel.push({
                            id: String(
                              row.oidDocumento ? row.oidDocumento : row.idVideo
                            ),
                            type: row.oidDocumento
                              ? EventAttachmentType.ATTACHMENT
                              : EventAttachmentType.VIDEO,
                          });
                        } else {
                          sel = sel.filter(
                            (aa) =>
                              aa.id !==
                              String(
                                row.oidDocumento
                                  ? row.oidDocumento
                                  : row.idVideo
                              )
                          );
                        }
                        setSelected(sel);
                      }}
                      disabled={
                        state.status === StepStatus.VISUALIZACAO &&
                        state.eventStatus === SituationValues.BLOCKED
                          ? false
                          : state.status === StepStatus.VISUALIZACAO ||
                            completedStep
                      }
                      anchorLabelToCheckbox={
                        state.status !== StepStatus.VISUALIZACAO ||
                        !completedStep
                      }
                    />
                  ),
                  title: (
                    <div>{row.oidDocumento ? row.nomDocumento : row.url}</div>
                  ),
                  description: (
                    <div>
                      <Collapse opened={!opened.includes(index)} animateOpacity>
                        <span className={styles.optionWidth}>
                          {row.desDocumento
                            ? row.desDocumento && row.desDocumento.length > 44
                              ? row.desDocumento.slice(0, 44) + '...'
                              : row.desDocumento
                              ? row.desDocumento
                              : '-'
                            : row.descricao && row.descricao.length > 44
                            ? row.descricao.slice(0, 44) + '...'
                            : row.descricao
                            ? row.descricao
                            : '-'}
                        </span>
                      </Collapse>
                      <Collapse
                        opened={
                          row.oidDocumento
                            ? opened.includes(index) &&
                              row.desDocumento &&
                              row.desDocumento.length > 44
                            : opened.includes(index) &&
                              row.descricao &&
                              row.descricao.length > 44
                        }
                        animateOpacity
                      >
                        {row.desDocumento ? row.desDocumento : row.descricao}
                      </Collapse>
                    </div>
                  ),
                  date: (
                    <div>
                      {isNullOrUndefined(row.dataCadastro)
                        ? '-'
                        : moment(row.dataCadastro).format('DD/MM/yyyy - HH:mm')}
                    </div>
                  ),
                  visibility: row.oidDocumento
                    ? row.flgDisponivelAssociado
                      ? 'Sim'
                      : 'Não'
                    : row.flagDisponivelAssociado
                    ? 'Sim'
                    : 'Não',
                  actions: (
                    <div
                      style={{
                        display: 'flex',
                        gap: '16px',
                        width: '100%',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <DropdownMenu
                        opened={String(dropOpened) === String(index)}
                        setOpened={(val) => toggleDropOpened(index, val)}
                        closeOnOutClick
                        content={
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            <DropdownItem
                              label={'Editar'}
                              onClick={() => {
                                toggleDropOpened(index, false);
                                row.idVideo
                                  ? openAddVideoModal([String(row.idVideo)])
                                  : openAddAttachmentModal([
                                      String(row.oidDocumento),
                                    ]);
                              }}
                            />
                            <DropdownItem
                              label={'Deletar'}
                              onClick={() => {
                                deleteModal(
                                  String(
                                    row.oidDocumento
                                      ? row.oidDocumento
                                      : row.idVideo
                                  ),
                                  row.idVideo ? true : false
                                );
                                toggleDropOpened(index, false);
                              }}
                            />
                          </div>
                        }
                      >
                        <IconButton
                          className={styles.option_icon}
                          icon={<OptionsIcon />}
                          onClick={() => {
                            toggleDropOpened(index, dropOpened !== index);
                          }}
                          disabled={
                            state.status === StepStatus.VISUALIZACAO &&
                            state.eventStatus === SituationValues.BLOCKED
                              ? false
                              : state.status === StepStatus.VISUALIZACAO ||
                                completedStep
                          }
                        />
                      </DropdownMenu>
                      <IconButton
                        className={clsx([
                          styles.chevron,
                          opened.includes(index) ? styles.active : '',
                        ])}
                        icon={<ChevronArrowDownIcon />}
                        onClick={(e) => {
                          let list = [...opened];
                          if (opened.indexOf(index)! > -1) {
                            list = list.filter((item) => item !== index);
                          } else {
                            list.push(index);
                            list = [index];
                          }
                          setOpened(list);
                          e.stopPropagation();
                        }}
                        disabled={
                          row.oidDocumento
                            ? !row.desDocumento ||
                              (row.desDocumento &&
                                row.desDocumento.length! <= 44)
                            : !row.descricao ||
                              (row.descricao && row.descricao.length! <= 44)
                        }
                      />
                    </div>
                  ),
                };
              })}
              upperHeader={{
                active: Boolean(selected!?.length),
                leftContent:
                  selected!?.length > 1
                    ? [showDeleteUpperHeaderButton(selected)]
                    : [
                        {
                          type: 'Button' as const,
                          leftIcon: <EditIcon />,
                          label: attachmentPrefix.Table.UpperHeader.Editar,
                          onClick: () => {
                            state.attachments.files.filter(() =>
                              selected[0].type ===
                              EventAttachmentType.ATTACHMENT
                                ? openAddAttachmentModal([selected[0].id])
                                : openAddVideoModal([selected[0].id])
                            );
                          },
                          disabled: selected!?.length! > 1 || !selected.length,
                        },
                        showDeleteUpperHeaderButton(selected),
                      ],
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col className={styles.paginationContainer}>
            <Pagination
              totalPages={
                state.attachments.files &&
                state.attachments.files.length / pageSize
              }
              currentPage={currentPage}
              onPageChange={(_, val) => {
                setCurrentPage(val);
                setSelected([]);
              }}
              countPages={{
                rows: pageSize,
                totalItems:
                  state.attachments.files && state.attachments.files.length,
              }}
            />
          </Col>
        </Row>
      </Collapse>
      <Row>
        <Col buttonActionsCol end>
          <Button
            theme={ButtonThemes.Secondary}
            onClick={() => {
              if (isAgn) {
                history.push(
                  `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pesquisa`
                );
              } else {
                if (props.reu) {
                  history.push(
                    `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/pauta`
                  );
                } else {
                  history.push(
                    `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pauta`
                  );
                }
              }
            }}
            leftIcon={<ArrowLeftIcon />}
          >
            {attachmentPrefix.Buttons.Voltar}
          </Button>
          <Button
            theme={ButtonThemes.Primary}
            onClick={() => {
              history.push(AssessorRoutePath);
            }}
            disabled={completedStep}
            leftIcon={<CheckCircleIcon />}
          >
            {attachmentPrefix.Buttons.Salvar}
          </Button>
          <Button
            theme={ButtonThemes.Primary}
            loading={loadingButton}
            disabled={
              state.eventStatus === SituationValues.BLOCKED ||
              completedStep ||
              loadingButton
            }
            onClick={handleSubmit}
          >
            {attachmentPrefix.Buttons.Disponibilizar}
          </Button>
        </Col>
      </Row>
    </Row>
  );
}
